/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface InscriptionSuspensionSearchDto
 */
export interface InscriptionSuspensionSearchDto {
    /**
     * 
     * @type {number}
     * @memberof InscriptionSuspensionSearchDto
     */
    idinscription?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InscriptionSuspensionSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof InscriptionSuspensionSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionSuspensionSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionSuspensionSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof InscriptionSuspensionSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof InscriptionSuspensionSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the InscriptionSuspensionSearchDto interface.
 */
export function instanceOfInscriptionSuspensionSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionSuspensionSearchDtoFromJSON(json: any): InscriptionSuspensionSearchDto {
    return InscriptionSuspensionSearchDtoFromJSONTyped(json, false);
}

export function InscriptionSuspensionSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionSuspensionSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinscription': !exists(json, 'idinscription') ? undefined : json['idinscription'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function InscriptionSuspensionSearchDtoToJSON(value?: InscriptionSuspensionSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinscription': value.idinscription,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

